module.exports = __webpack_public_path__ + "img/hungary.34578b0.webp";